var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 52,
    viewBox: "0 0 48 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    clipPath: "url(#clip0_2_30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4956 0C31.1904 1.70435 32.4097 4.09586 32.0754 6.60313C31.5272 8.96509 29.2017 11.0684 27.3899 12.3442C23.5796 15.0288 18.0608 17.3612 13.3729 15.8859C9.70521 14.7333 10.5336 10.5291 10.4402 10.9896C10.0838 12.7506 10.4919 14.7382 11.9373 15.9401C13.2476 17.0287 15.4748 17.3194 17.1193 17.3144C18.5918 17.3095 20.1061 17.0411 21.5565 16.6864C20.6519 17.1617 19.7202 17.5928 18.7467 17.9622C14.8676 19.435 11.6227 18.8119 8.29909 19.6518C2.20752 21.1862 0 26.9519 0 26.9519C0 26.9519 2.72375 21.132 13.84 21.4202C13.926 21.4152 14.167 21.4423 14.2505 21.4374C9.90925 24.3387 7.48049 28.5183 11.6571 37.7199C10.7918 24.3658 23.4592 23.3339 30.3226 19.573C40.753 13.8565 41.4881 2.67229 27.4956 0Z",
    fill: "url(#paint0_linear_2_30)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.928 29.0922C43.8283 30.2301 45.2541 30.5207 47.9999 30.3877L47.0486 29.8582C45.7555 29.304 45.5171 29.144 44.3568 28.2992C40.4752 25.388 40.871 19.2528 40.5809 14.886C40.3941 12.3935 40.0892 10.0833 39.2756 8.0489C39.0617 7.51198 38.3267 6.41351 38.3267 6.41351C39.5042 10.4207 39.4083 12.6324 37.068 17.4795C34.5065 22.7822 39.2854 25.6786 35.748 26.181C33.3192 26.5259 33.978 26.9495 34.1108 28.2179C34.1894 29.0898 33.6363 29.1169 32.685 29.2228C32.8423 30.836 32.9234 30.6242 31.5247 30.836C30.0448 31.0478 31.419 34.4861 28.4346 33.826C26.5614 33.4024 25.4503 31.5773 22.8642 31.6291C16.4752 37.9514 26.8245 42.1039 30.652 51.3892C31.2862 47.4756 26.559 41.9463 32.4736 38.1903C30.7577 42.8995 30.5192 48.6135 34.9539 52C34.6098 50.7562 33.951 49.5666 33.7936 48.0322C33.5822 45.9166 33.7396 43.4807 34.3468 41.498C37.1197 32.267 33.4495 47.2121 43.1645 48.8524C41.1315 46.6579 39.9614 45.4387 40.1827 41.5522C40.5465 35.1412 40.4383 34.5994 39.31 31.8433C39.5828 32.5108 42.0559 33.9344 43.639 36.8431C45.4605 40.2296 44.5633 41.4192 44.2191 44.7787C49.3446 34.4885 41.7412 33.2201 41.928 29.0922Z",
    fill: "url(#paint1_linear_2_30)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7147 3.58847C18.7835 3.5269 19.9512 4.80762 21.0132 6.84447C21.0157 6.82477 21.0206 6.80753 21.023 6.78536C21.7015 2.14519 16.0155 0.497485 14.3538 0.226562C16.8882 2.26834 17.1119 8.91826 20.7354 7.79763C19.9488 6.12037 19.108 4.28056 18.7147 3.58847Z",
    fill: "url(#paint2_linear_2_30)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1917 5.36185C23.5698 5.99236 23.1003 6.46278 22.3874 8.17944C22.3849 8.1622 22.38 8.14743 22.3775 8.13019C21.6327 4.26338 26.9818 2.81024 27.9357 2.71912C26.2321 4.49489 24.6883 10.7163 22.6553 8.96758C22.9773 7.35929 23.7664 6.05393 24.1917 5.36185Z",
    fill: "url(#paint3_linear_2_30)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2029 10.1744C18.1666 9.75079 18.8893 9.42814 21.1017 9.36657C21.0845 9.35425 21.0698 9.3444 21.0501 9.33209C17.0775 6.85191 13.1837 12.1916 12.6748 13.2137C15.374 12.0733 23.4813 12.5364 21.8613 9.99708C19.9365 9.67444 18.1494 9.99462 17.2029 10.1744Z",
    fill: "url(#paint4_linear_2_30)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.87329 17.5509C1.91016 17.4868 3.28187 17.3612 3.86448 16.8834C4.63146 16.4475 3.74649 15.6323 2.25678 17.0657C2.11912 17.2135 1.98883 17.376 1.87329 17.5509Z",
    fill: "url(#paint5_linear_2_30)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.94495 13.7802C4.41499 13.5979 5.08118 12.8147 6.38651 12.694C7.91309 12.5512 8.25479 15.0781 4.73456 14.3713C3.96021 14.2161 3.29402 13.8812 2.94495 13.7802Z",
    fill: "url(#paint6_linear_2_30)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_30",
    x1: 7.84898,
    y1: 14.5675,
    x2: 36.6132,
    y2: 24.7003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97165E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.017
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5236
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7272
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_30",
    x1: 30.4432,
    y1: 25.2205,
    x2: 41.1984,
    y2: 34.9701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_30",
    x1: 14.3529,
    y1: 4.07468,
    x2: 21.0781,
    y2: 4.07468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.017
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_30",
    x1: 22.3038,
    y1: 5.99807,
    x2: 27.9324,
    y2: 5.99807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0208333,
    stopColor: "#214F2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_30",
    x1: 12.6748,
    y1: 10.9488,
    x2: 22.0732,
    y2: 10.9488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5236,
    stopColor: "#214F2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7272,
    stopColor: "#214F2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#214F2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_30",
    x1: 1.87305,
    y1: 16.9018,
    x2: 4.14696,
    y2: 16.9018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.017
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1746
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3426
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5236
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7272,
    stopColor: "#214F2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_30",
    x1: 2.94608,
    y1: 13.5924,
    x2: 7.48602,
    y2: 13.5924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#214F2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#214F2A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_30"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 52,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.981b520efa221db35ad7c263a41577cc.svg";
export { ForwardRef as ReactComponent };